<template>
  <div>
    <div
      class="carousel"
      @mousedown="handleMouseDown"
      @mouseup="handleMouseUp"
      @mouseleave="handleMouseLeave"
      @mousemove="handleMouseMove"
      @touchstart="handleMouseDown"
      @touchend="handleMouseUp"
      @touchcancel="handleMouseLeave"
      @touchmove="handleMouseMove"
    >
      <div class="inner" :style="{ transform: 'translateX(' + -currentIndex * 100 + '%)' }">
        <slot />
      </div>
    </div>
    <div class="carousel-dots">
      <span
        v-for="(item, index) in items"
        :key="index"
        :class="['dot', { active: index === currentIndex }]"
        @click="goTo(index)"
      ></span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DashboardAdCard',
  props: {},
  components: {},
  data() {
    return {
      currentIndex: 0,
      items: [1, 2],
      transitioning: false,
      intervalId: null,
    };
  },

  mounted() {
    this.startInterval();
  },

  methods: {
    next() {
      if (this.transitioning) return;

      this.transitioning = true;

      this.currentIndex = (this.currentIndex + 1) % this.items.length;

      this.transitioning = false;
      this.resetInterval();
    },

    prev() {
      if (this.transitioning) return;

      this.transitioning = true;

      this.currentIndex = (this.currentIndex - 1 + this.items.length) % this.items.length;

      this.transitioning = false;
      this.resetInterval();
    },

    goTo(index) {
      this.currentIndex = index;
      this.resetInterval();
    },

    startInterval() {
      this.intervalId = setInterval(() => {
        this.next();
      }, 4000); // Change interval time here (5000ms = 5 seconds)
    },
    resetInterval() {
      clearInterval(this.intervalId);
      this.startInterval();
    },
    handleMouseDown(event) {
      this.isDragging = true;
      this.startX = event.clientX || event.touches[0].clientX;
    },
    handleMouseUp() {
      this.isDragging = false;
    },
    handleMouseLeave() {
      if (this.isDragging) {
        this.isDragging = false;
      }
    },
    handleMouseMove(event) {
      if (this.isDragging) {
        const currentX = event.clientX || event.touches[0].clientX;
        const difference = currentX - this.startX;
        if (difference > 50) {
          this.prev();
          this.isDragging = false;
        } else if (difference < -50) {
          this.next();
          this.isDragging = false;
        }
      }
    },
  },
};
</script>

<style>
.carousel {
  width: 100%;
  overflow: hidden;
  position: relative;
  margin: 0 auto;
}

.inner {
  display: flex;
  transition: transform 0.5s ease;
}

.card {
  flex: 0 0 100%;
}

.carousel-dots {
  text-align: center;
  margin-top: -40px;
  position: relative;
}
.dot {
  display: inline-block;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: #ccc;
  margin: 0 5px;
  cursor: pointer;
}
.dot.active {
  background-color: #333;
}
</style>
